export const LEGALBRIDGE_LOADING = "LEGALBRIDGE_LOADING";
export const LEGALBRIDGE_RESET = "LEGALBRIDGE_RESET";
export const GET_LEGALBRIDGE = "GET_LEGALBRIDGE";
export const GET_LEGALBRIDGE_SUCCESS = "GET_LEGALBRIDGE_SUCCESS";
export const GET_LEGALBRIDGE_FAIL = "GET_LEGALBRIDGE_FAIL";
export const DELETE_LEGALBRIDGE = "DELETE_LEGALBRIDGE"
export const DELETE_LEGALBRIDGE_SUCCESS = "DELETE_LEGALBRIDGE_SUCCESS"
export const DELETE_LEGALBRIDGE_FAIL = "DELETE_LEGALBRIDGE_FAIL"
export const UPDATE_LEGALBRIDGE = "UPDATE_LEGALBRIDGE"
export const UPDATE_LEGALBRIDGE_SUCCESS = "UPDATE_LEGALBRIDGE_SUCCESS"
export const UPDATE_LEGALBRIDGE_FAIL = "UPDATE_LEGALBRIDGE_FAIL"
export const ADD_NEW_LEGALBRIDGE = "ADD_NEW_LEGALBRIDGE"
export const ADD_LEGALBRIDGE_SUCCESS = "ADD_LEGALBRIDGE_SUCCESS"
export const ADD_LEGALBRIDGE_FAIL = "ADD_LEGALBRIDGE_FAIL"